import { ParsedUrlQuery } from 'querystring';

import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { FILTER_TYPE } from '@components/editorialList/editorialList.constants';

import { Container, FilterOption, InnerContainer } from './editorialFilter.styles';

type FilterItem = {
  label: string;
  query: FILTER_TYPE;
};

export interface EditorialFilterProps {
  items: FilterItem[];
  filterArticles?: (query: FILTER_TYPE) => void;
  params: ParsedUrlQuery;
  setParams: React.Dispatch<React.SetStateAction<ParsedUrlQuery>>;
}

export const EditorialFilter = ({ items, filterArticles, params, setParams }: EditorialFilterProps) => {
  const router = useRouter();
  const { query } = router;
  const [activeOption, setActiveOption] = useState(query.filter || FILTER_TYPE.ALL);

  useEffect(() => {
    if (activeOption) {
      setParams({ ...params, filter: activeOption });
    }
  }, [activeOption]);

  return (
    <Container>
      <InnerContainer>
        {items.map(({ label, query }, index) => (
          <FilterOption
            onClick={() => {
              if (filterArticles) {
                setActiveOption(query);
                filterArticles(query);
                void router.push({
                  pathname: router.pathname,
                  query: { filter: query },
                });
              }
            }}
            isActive={activeOption === query}
            key={index}
          >
            {label}
          </FilterOption>
        ))}
      </InnerContainer>
    </Container>
  );
};
